import { render, staticRenderFns } from "./EsPromo.vue?vue&type=template&id=0936e27f&scoped=true"
import script from "./EsPromo.vue?vue&type=script&lang=js"
export * from "./EsPromo.vue?vue&type=script&lang=js"
import style0 from "./EsPromo.vue?vue&type=style&index=0&id=0936e27f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0936e27f",
  null
  
)

export default component.exports